import request from './http';
/**
 * 留言
 * @param {Object} current 
 * @returns 
 */
export const leaveMessages = function (current) {
  return request.post("/zhcpw/leaveMessages/create", current);
}